<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import formtreeselect from "../formcomponet/formtreeselect.vue";
import muayenekabulraporu from "./muayenekabulraporu.vue";
import satdosyafatura from "../satdosyafatura/addedit.vue";
export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FormData: {},
      TableData: null,
      MuayeneKabulUpdate: 0,
      gecersiz_teklifler: [],
      gecerli_teklifler: [],
      FirmaId: null,
      Firmalar: {},
      SatDosya: null,
      FormDataType: {
        FirmaId: {
          FieldName: "FirmaId",
          Field: "input",
          FieldTitle: this.$t("muayenekabulkomisyonu.Page.Firma"),
          ComboDataArray: [],
        },
      },
    };
  },
  validations: {
    FirmaId: {},
  },
  components: {
    Loader,
    formtreeselect,
    muayenekabulraporu,
    satdosyafatura,
  },
  watch: {
    satdosyaId() { },
  },
  methods: {
    onSubmit() {
      this.Update("satdosya", this.FormData).then((res) => {
        if (res) {
          //this.$bvModal.hide("piyasaarastirmagorevliler");
        }
      });
    },
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.FormData = res.Data;
        this.SatDosya = res.Data;

        this.ActionsSingleGet({
          Service: "okeyvalues",
          Id: res.Data.Ihaleturu,
        }).then((ihaleturu) => {

          if (!this.FormData.Muayenekabulkomisyonu) {
            this.FormData.Muayenekabulkomisyonu = [];
          }

          let Page = {
            PageNumber: "1",
            PageSize: "99999",
            PageDataSize: "1",
          };

          if (res.Data.Teklifdegerlendirmeyontem == 1) {
            this.ActionsFilterGet({
              Service: "satdosyamalzeme",
              Page: Page,
              Filter: "&Dosyaid=" + this.satdosyaId,
            }).then((res) => {
              this.FirmaId = res.Data[0].Kazananfirmaid;

            });
          }



          var Fiyatturu = null;

          if (
            ihaleturu.Data.Kod == 9 ||
            ihaleturu.Data.Kod == 10 ||
            ihaleturu.Data.Kod == 11 ||
            ihaleturu.Data.Kod == 12 ||
            ihaleturu.Data.Kod == 13 ||
            ihaleturu.Data.Kod == 14 ||
            ihaleturu.Data.Kod == 15 ||
            ihaleturu.Data.Kod == 16 ||
            ihaleturu.Data.Kod == 17 ||
            ihaleturu.Data.Kod == 18 ||
            ihaleturu.Data.Kod == 21
          ) {
            Fiyatturu = 2;
          } else {
            Fiyatturu = 3;
          }
          this.ActionsFilterGet({
            Service: "satdosyafirma",
            Page: Page,
            Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=" + Fiyatturu,
          }).then((res) => {
            this.TableData = res.Data;
            if (this.FormData.Teklifdegerlendirmeyontem != 2) {
              this.teklifkontrol().then();
            } else {
              this.Firmalar = {}
              this.ActionsFilterGet({
            Service: "SatDosyaMalzeme",
            Page: Page,
            Filter: "&Dosyaid=" + this.satdosyaId,
          }).then((resp) => {
            this.Firmalar = this.groupBy(resp.Data, "Kazananfirmaid");
            for(let Firma in this.Firmalar){  
                this.FormDataType.FirmaId.ComboDataArray.push({
                  id: this.Firmalar[Firma][0].Kazananfirmaid,
                  label: this.Firmalar[Firma][0].Kazananfirmaadi,
                });
              }
            });
            }
   
          });
        });
      });
      this.$emit("aktif_menu_title", this.$t("muayenekabulkomisyonu.Title"));
    },
    groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    },
    teklifkontrol() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "satdosyazarfacmakontrol",
        Page: Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((ressatdosyazarfacmakontrol) => {
        if (ressatdosyazarfacmakontrol) {
          this.gecersiz_teklifler = [];
          this.gecerli_teklifler = [];
          for (var j = 0; j < ressatdosyazarfacmakontrol.Data.length; j++) {
            let istenenbelgeler = JSON.parse(
              ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler
            );

            // alert(Object.values(istenenbelgeler)[0])
            let belge_kontrol = 0;

            for (var i = 0; i < Object.values(istenenbelgeler).length; i++) {
              if (Object.values(istenenbelgeler)[i] > 1) {
                belge_kontrol = 1;
              }
            }

            let zarffirma = "";
            for (i = 0; i < this.TableData.length; i++) {
              if (
                this.TableData[i].Id ==
                ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid
              ) {
                zarffirma = this.TableData[i];
              }
            }
            if (belge_kontrol == 0) {
              this.gecerli_teklifler.push(zarffirma);
            } else {
              this.gecersiz_teklifler.push(zarffirma);
            }
          }

          this.gecerliteklifler();
        }
      });
    },
    gecerliteklifler() {
      for (var i = 0; i < this.gecerli_teklifler.length; i++) {
        this.FormDataType.FirmaId.ComboDataArray.push({
          id: this.gecerli_teklifler[i].Id,
          label: this.gecerli_teklifler[i].Firmaadi,
        });
      }
    },

    AddGorevli() {
      this.FormData.Muayenekabulkomisyonu.push({ AdSoyad: "", Unvan: "" });
    },
    DelGorevli(index) {
      this.FormData.Muayenekabulkomisyonu.splice(index, 1);
    },
  },
};
</script>
<template>
  <Loader>
    <Form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <formtreeselect v-if="FormData.Teklifdegerlendirmeyontem == 2" :labels_lg="4"
                    :FormDataType="FormDataType.FirmaId" :Value="FirmaId" :v="$v.FirmaId" @input="FirmaId = $event" />
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" v-b-modal.satdosyafatura>
                      <i class="mdi mdi-beaker-plus me-1"></i>
                      {{
                        $t(
                          "muayenekabulkomisyonu.Page.muayenekabulraporubilgileri"
                        )
                      }}
                    </button>

                    <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" v-b-modal.muayenekabulraporu>
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("muayenekabulkomisyonu.Page.muayenekabulraporu") }}
                    </button>
                  </div>
                </div>
              </div>

              <div class="inner-repeater mb-4">
                <div class="inner mb-3">
                  <div v-for="(data, index) in FormData.Muayenekabulkomisyonu" :key="data.id" class="inner mb-3 row">
                    <div class="col-md-5 col-4">
                      <label>{{
                        $t("muayenekabulkomisyonu.AddEdit.AdSoyad")
                      }}</label>
                      <input v-model="data.AdSoyad" :disabled="SatDosya.Tamamlandi" type="text" class="inner form-control" />
                    </div>
                    <div class="col-md-5 col-4">
                      <label>{{
                        $t("muayenekabulkomisyonu.AddEdit.Unvan")
                      }}</label>
                      <input v-model="data.Unvan" :disabled="SatDosya.Tamamlandi" type="text" class="inner form-control" />
                    </div>
                    <div class="col-md-1 col-4">
                      <label> &nbsp;</label>
                      <div class="d-grid">
                        <input type="button" class="btn btn-primary btn-block"
                          :value="$t('muayenekabulkomisyonu.AddEdit.Sil')" @click="DelGorevli(index)"
                          v-if="!SatDosya.Tamamlandi" />
                      </div>
                    </div>
                  </div>

                  <div class="text-sm-end">
                    <div class="row">
                      <div class="col-1">
                        <button v-if="!SatDosya.Tamamlandi"
                          class="btn btn-primary" type="submit">
                          {{ $t("muayenekabulkomisyonu.AddEdit.Button") }}
                        </button>
                      </div>

                      <div class="col-11">
                        <input type="button" class="btn btn-success inner"
                          :value="$t('muayenekabulkomisyonu.AddEdit.Ekle')" @click="AddGorevli"
                          v-if="!SatDosya.Tamamlandi" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <satdosyafatura v-if="FirmaId" :satdosyaId="satdosyaId" :Firmaid="FirmaId" :Tamamlandi="SatDosya.Tamamlandi" :SatDosya="SatDosya" @TableUpdate="MuayeneKabulUpdate = 1"/>
    <muayenekabulraporu v-if="FirmaId" :satdosyaId="satdosyaId" :FirmaId="FirmaId" :MuayeneKabulUpdate ="MuayeneKabulUpdate" @TableUpdate="MuayeneKabulUpdate = 0"/>
  </Loader>
</template>
